import { 
  Component, 
  OnInit, 
  Input,   
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

  @Input() isTitleForm: boolean;
  @Input() titleForm: string;

  usernameLabel: string = 'Username';
  passwordLabel: string = 'Password';
  emailLabel: string = 'Email';

  @Input() passwordPlaceHolder: string = 'Password';
  @Input() usernamePlaceHolder: string = 'username';
  @Input() emailPlaceHolder: string = 'Email';
  @Input() nameLoginBtn: string = 'Login';

  @Input() errorPwdRequired: string = "Password is required";
  @Input() errorPwdLength: string = "Password need to be min. 6";
 
  @Input() passwordLength: number = 6;
  @Input() errorServer:string;
  
  loginForm: UntypedFormGroup;
  

  constructor(
    private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: new UntypedFormControl('alessio.corsini@gmail.com', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.pattern(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)
      ])),
      username: new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10)
      ])),
      password: new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(this.passwordLength)
      ]))
    });
  }

  @Output() submit = new EventEmitter<string>();
  
  formSubmit(ev){
    ev.stopPropagation();
    ev.preventDefault();
    //if (this.loginForm.dirty && this.loginForm.valid)
    console.log("this.loginForm.value", this.loginForm.value)
        this.submit.emit(this.loginForm.value);
  }

}

